import { render, staticRenderFns } from "./StatisticsGroup.vue?vue&type=template&id=3fd48cc6&"
import script from "./StatisticsGroup.vue?vue&type=script&lang=ts&"
export * from "./StatisticsGroup.vue?vue&type=script&lang=ts&"
import style0 from "./StatisticsGroup.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports